import { IGroup } from '../types';

export const addGroup = ({
  groups,
  parameterId,
  newIdCounter,
}: {
  groups: IGroup[];
  parameterId: number;
  newIdCounter: number;
}) => {
  const newItemGroup = {
    id: `new-${parameterId}-${newIdCounter}`,
    isExpanded: true,
    name: '',
    items: [],
  };

  return {
    groups: groups.map(group => {
      if (group.parameter.id === parameterId) {
        return {
          ...group,
          itemGroups: [...group.itemGroups, newItemGroup],
        };
      }
      return group;
    }),
  };
};



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/services/addGroup.ts